/**
 *
 *  Replaces the value of a given attribute.
 *
 *  Requires an attribute selector, attribute name, and attribute value in 
 *  the event data.
 */

var sw = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');

sw.on('sw-change-attr', function(eventData) {
  var attr = eventData.attr;
  var attrSelector = eventData.attrSelector;
  var attrValue = eventData.attrValue;

  var currentAttrVal = $(attrSelector).attr(attr);

  if (currentAttrVal !== attrValue) {
    $(attrSelector).attr(attr, attrValue);
  }
  
});
